module.exports = __webpack_public_path__ + "img/hero-counseling-mobile.bc7aec2d.svg";